export default {

	/*******************************************************
	* tag config
	*	path => config
	*******************************************************/
	'firearms': {
        params: {
            tags: "firearm,firearms,hand guns,long guns,shotguns,rifles,pistols,modern sporting rifles,rifles by caliber,rifles - not used",
            tags_not: "ammo,ammunition,accessories,holsters"
        }
    },
    'handguns': {
        params: {
            tags: "handguns,handgun,pistols",
            tags_not: "ammo,ammunition,accessories,holsters,rifle accessories"
        },
        showBrands: true,
        brands: ['beretta', 'cz', 'colt', 'fn', 'glock', 'sig', 'sw', 'springfield', 'taurus', 'walther', 'kimber', 'psa']
    },
    'rifles': {
        params: {
            tags: "long guns,longguns,rifle,rifles,modern sporting rifles,rifles by caliber,rifles - not used",
            tags_not: "ammo,ammunition,accessories,holsters"
        },
        showBrands: true,
        brands: ['ruger', 'psa', 'kel-tec', 'springfield', 'sig', 'fn', 'remington', 'savage', 'howa', 'henry', 'mossberg', 'arsenal', 'cz']
    },
    'shotguns': {
        params: {
            tags: "shotguns,shotgun",
            tags_not: "ammo,ammunition,accessories,holsters,hand guns"
        },
        showBrands: true,
        brands: ['remington', 'mossberg', 'benelli', 'beretta', 'kel-tec', 'browning', 'cz', 'stoeger', 'franchi', 'maverick']
    },
    'ammo': {
        params: {
            tags: "ammo,ammunition,bullets,rifle ammo,rifle ammunition,handgun ammo, handgun ammunition",
            tags_not: "firearms,hand guns,long guns"
        }
    },
    'ammunition': {
        params: {
            tags: "ammo,ammunition,bullets,rifle ammo,rifle ammunition,handgun ammo, handgun ammunition",
            tags_not: "firearms,hand guns,long guns"
        }
    },
    'knives': {
        params: {
            tags: "knife,knives,sword,folding knives,all knives,fixed knives"
        },
        showBrands: true,
        brands: ['benchmade', 'spyderco', 'boker', 'microtech', 'kershaw', 'zero-tolerance', 'protech', 'gerber', 'crkt']
    },
    'optics': {
        params: {
            tags: "optics and sights,handgun scopes & sights,rifle scopes,red dot sights,tritium & fiber optic night sights",
            tags_not: "ammo,ammunition,accessories,holsters"
        },
        showBrands: true,
        brands: ['aimpoint', 'eotech', 'sig', 'holosun', 'primary-arms', 'vortex', 'leupold', 'bushnell', 'trijicon', 'nightforce', 'schmidt and bender', 'burris']
    },
    'safes': {
        params: {
            tags: "safes,gun storage"
        }
    }

};